import { forwardRef } from 'react'
import { SnackbarComponent } from '..'
import { CloseIcon } from '$common/icons/close'
import { ForwardIcon } from '$common/icons/forward'

interface Props {
  text: string
  close: () => unknown
  icon?: JSX.Element
}

export const SuccessSnackbar = forwardRef(function SuccessSnackbar(
  { text, icon, close }: Props,
  ref,
) {
  return (
    <SnackbarComponent
      ref={ref}
      text={text}
      button={<CloseIcon sx={{ color: 'gray' }} />}
      icon={icon}
      color="success.main"
      bgcolor="success.light"
      onClick={close}
    />
  )
})

SuccessSnackbar.defaultProps = {
  icon: <ForwardIcon />,
}
